import React from "react";
import { Typography, CardMedia, Box, useTheme } from "@mui/material";
import { getCardStyles, imageStyles } from "./styles";

interface IProps {
  title: string;
  iconUrl: string;
}

const BenefitCard: React.FC<IProps> = ({ title, iconUrl }) => {
  const theme = useTheme();

  return (
    <Box sx={getCardStyles(theme)}>
      <CardMedia component="img" image={iconUrl} alt={title} sx={imageStyles} />
      <Typography variant="h4" component="h3" color="text.primary">
        {title}
      </Typography>
    </Box>
  );
};

export default BenefitCard;
